import ImageWrapper from "ol/Image";
import { Image as ImageLayer } from "ol/layer.js";
import ImageWMS from "ol/source/ImageWMS.js";
import { API_BASE_URL } from "~/config";
import { LayerDefaults, LayerTitle } from "../types/layers";
import { readMapSettings } from "./localMapSettings";

async function customLoader(
  tile: ImageWrapper,
  src: string,
  getToken: () => Promise<string | undefined>,
) {
  const token = await getToken();

  const client = new XMLHttpRequest();
  client.open("GET", src);
  client.responseType = "blob";
  client.setRequestHeader("authorization", `Bearer ${token}`);

  client.onload = function customOnLoad() {
    // eslint-disable-next-line no-param-reassign
    (tile.getImage() as HTMLImageElement).src = URL.createObjectURL(
      this.response,
    );
  };

  client.send();
}
export const createIceLayer = (getToken: () => Promise<string | undefined>) => {
  const title = LayerTitle.IceLevel;
  const layers = new ImageLayer({
    source: new ImageWMS({
      url: `${API_BASE_URL}/api/thirdparty/ice?wms??`,

      params: {
        layers: "fmi:ice:icechart_arctia_ui",
        VERSION: "1.3.0",
        // time: "2022-02-20T10:35:39Z",

        // time: sub(new Date(), { years: 1 }).toISOString(),
      },
      ratio: 1,
      serverType: "geoserver",
      projection: "EPSG:4326",

      imageLoadFunction: (tile, e) => {
        void customLoader(tile, e, getToken);
      },
    }),
    zIndex:
      readMapSettings("layers", title)?.zIndex ?? LayerDefaults[title].zIndex,
    visible:
      readMapSettings("layers", title)?.visible ?? LayerDefaults[title].visible,
    opacity: 0.85,
  });
  layers.set("title", title);
  return { layers };
};
